import PrivateRoute from 'components/PrivateRoute';
import React from 'react';
import { Switch } from 'react-router';
import ReportListPage from './pages/ReportListPage';
import ReportViewPage from './pages/ReportViewPage';
import ReportFormPage from './pages/ReportFormPage';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/relatorios"
      permission="reports.view_sqlreport"
      component={ReportListPage}
    />
    <PrivateRoute
      exact
      path="/relatorios/:id/edit"
      permission="reports.change_sqlreport"
      component={ReportFormPage}
    />
    <PrivateRoute
      exact
      path="/relatorios/new"
      permission="reports.add_sqlreport"
      component={ReportFormPage}
    />
    <PrivateRoute
      exact
      path="/relatorios/:id"
      permission="reports.view_sqlreport"
      component={ReportViewPage}
    />
  </Switch>
);
